/**
 * <BulletList> — a simple bulleted list of strings (molecule, L0.1).
 *
 * Maps `items` to "• text" rows. Used for the "Bilan de la session" body on the report page,
 * but generic. Composes DS atoms only — `<Stack>`, `<Row>`, `<Text>`. No hex.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { type SpacingKey } from "../../theme/tokens/spacing"
import { Paragraph } from "../../atoms/typography/Paragraph"

export type BulletListProps = {
    items: string[]
    /** Vertical gap between rows — spacing token, default `"2"`. */
    gap?: SpacingKey
    testID?: string
}

export function BulletList(props: BulletListProps) {
    const { items, gap = "2", testID } = props

    return (
        <Stack gap={gap} testID={testID}>
            {items.map((item, index) => (
                <Row key={index} gap="2" align="start">
                    <Text weight="bold" size="text-2xl" color="text-primary">
                        •
                    </Text>
                    <Paragraph>{item}</Paragraph>
                </Row>
            ))}
        </Stack>
    )
}
